var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 155,
    viewBox: "0 0 290 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_14778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.739 135.998C229.242 124.958 270.401 83.9901 279.285 39.0018C279.737 38.715 280.186 38.4278 280.638 38.144C279.114 53.8799 277.552 69.6119 276.174 85.363C275.876 88.7862 283.235 89.5556 283.593 86.1295C285.465 68.0914 287.09 50.0279 288.816 31.9777C289.03 29.7376 285.021 27.8768 282.607 29.4136C281.402 30.1776 280.202 30.9452 278.997 31.7092C277.411 30.5932 274.662 30.297 273.371 31.7769C270.251 35.3514 266.868 38.6529 263.223 41.7425C255.085 46.9182 246.947 52.0908 238.812 57.2699C235.275 59.5185 239.838 63.4743 243.72 61.6161C253.343 57.0154 261.596 51.7546 268.805 45.6641C269.272 45.3666 269.742 45.0695 270.209 44.772C259.178 85.0292 221.191 120.648 164.969 131.136C107.285 141.898 40.8406 123.151 6.90565 85.0654C5.94241 83.9864 3.44368 85.0322 4.36525 86.1463C37.5232 126.305 107.198 146.513 166.739 135.998Z",
    fill: "url(#paint0_linear_333_14778)",
    stroke: "#03112C",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_333_14778",
    x1: 282.996,
    y1: 91.9102,
    x2: 6.46679,
    y2: 63.3394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69179F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5B6E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_14778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 289.463,
    height: 153.75,
    fill: "white",
    transform: "translate(0 0.749878)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.536f92b885da9deb011d943bba3b8f33.svg";
export { ForwardRef as ReactComponent };